import React from 'react'

const Social = () => {
  return (
    <div className="home__social">
        <a href="https://www.instagram.com/victor.prime_time/" className="home__social-icon">
            <i className="uil uil-instagram"></i>
        </a>

        <a href="https://www.linkedin.com/in/victor-phan-07b2951b1/" className="home__social-icon">
            <i className="uil uil-linkedin"></i>
        </a>

        <a href="https://github.com/victorphan101" className="home__social-icon">
            <i className="uil uil-github-alt"></i>
        </a>

    </div>
  )
}

export default Social
